var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        id: "grapes",
        xmlns: "http://www.w3.org/2000/svg",
        width: "100",
        height: "100",
        viewBox: "0 0 100 100",
      },
    },
    [
      _c("path", {
        staticStyle: { "stroke-width": "0px" },
        attrs: {
          d: "m63.362,29.469c-.08-.402-.322-.724-.724-.724-.241,0-4.427-.241-7.969,1.529.563-1.127.966-2.415.966-3.783.08-5.071-4.991-9.096-5.152-9.257-.322-.241-.724-.241-.966,0-.241.161-5.313,4.105-5.393,9.176,0,1.449.402,2.817.966,4.025-3.622-1.69-7.808-1.368-8.049-1.288-.402,0-.724.322-.724.724,0,.241-.402,6.037,3.381,9.418,2.817,2.495,7.164,2.817,9.176,2.817h1.771c1.771,0,6.601-.241,9.579-3.139,3.703-3.461,3.139-9.257,3.139-9.498h0Zm-13.442-10.544c1.207,1.127,4.105,4.105,4.105,7.567s-2.978,6.44-4.186,7.486c-1.207-1.127-4.105-4.105-4.105-7.567s2.978-6.44,4.186-7.486h0Zm-9.096,19.077c-2.495-2.173-2.817-5.876-2.898-7.406,1.69,0,5.876.161,8.371,2.415,2.495,2.173,2.817,5.876,2.898,7.406-1.69.081-5.796-.161-8.371-2.415h0Zm9.981,2.496c0-1.529.241-5.232,2.656-7.486,2.495-2.334,6.681-2.656,8.291-2.656,0,1.529-.241,5.232-2.656,7.486-2.415,2.334-6.601,2.576-8.291,2.656Z",
        },
      }),
      _c("path", {
        staticStyle: { "stroke-width": "0px" },
        attrs: {
          d: "m36.479,50.636c0-2.656-2.093-4.749-4.749-4.83-1.288,0-2.495.483-3.381,1.368s-1.449,2.093-1.449,3.381.483,2.495,1.368,3.381,2.093,1.449,3.381,1.449,2.415-.483,3.381-1.368c.966-.885,1.449-2.092,1.449-3.38h0Zm-2.496,2.254c-.563.563-1.368.885-2.254.885-.805,0-1.61-.322-2.254-.966s-.885-1.368-.885-2.254c0-.805.322-1.61.966-2.254.563-.563,1.368-.885,2.254-.885,1.771,0,3.139,1.449,3.139,3.22-.081.886-.402,1.69-.966,2.254h0Z",
        },
      }),
      _c("path", {
        staticStyle: { "stroke-width": "0px" },
        attrs: {
          d: "m48.391,50.636c0-2.656-2.093-4.749-4.749-4.83-1.288,0-2.495.483-3.381,1.368s-1.449,2.093-1.449,3.381.483,2.495,1.368,3.381c.885.885,2.093,1.449,3.381,1.449s2.415-.483,3.381-1.368c.885-.885,1.449-2.092,1.449-3.38h0Zm-2.576,2.254c-.563.563-1.368.885-2.254.885-.805,0-1.61-.322-2.254-.966-.644-.644-.885-1.368-.885-2.254,0-.805.322-1.61.966-2.254.563-.563,1.368-.885,2.254-.885,1.771,0,3.139,1.449,3.139,3.22,0,.886-.403,1.69-.966,2.254h0Z",
        },
      }),
      _c("path", {
        staticStyle: { "stroke-width": "0px" },
        attrs: {
          d: "m56.438,55.385c1.288,0,2.415-.483,3.381-1.368.885-.885,1.449-2.093,1.449-3.381,0-2.656-2.093-4.749-4.749-4.83-1.288,0-2.495.483-3.381,1.368s-1.449,2.093-1.449,3.381.483,2.495,1.368,3.381c.885.886,2.092,1.449,3.381,1.449h0Zm-3.139-4.749c0-.805.322-1.61.966-2.254.563-.563,1.368-.885,2.254-.885,1.771,0,3.139,1.449,3.139,3.22,0,.805-.322,1.61-.966,2.254-.563.563-1.368.885-2.254.885-.805,0-1.61-.322-2.254-.966-.644-.644-.885-1.449-.885-2.254h0Z",
        },
      }),
      _c("path", {
        staticStyle: { "stroke-width": "0px" },
        attrs: {
          d: "m68.351,45.887c-1.288,0-2.495.483-3.381,1.368s-1.449,2.093-1.449,3.381.483,2.495,1.368,3.381,2.093,1.449,3.381,1.449,2.415-.483,3.381-1.368c.885-.885,1.449-2.093,1.449-3.381,0-2.656-2.173-4.829-4.749-4.829h0Zm2.173,7.003c-.563.563-1.368.885-2.254.885-.805,0-1.61-.322-2.254-.966-.644-.644-.885-1.368-.885-2.254,0-.805.322-1.61.966-2.254.563-.563,1.368-.885,2.254-.885,1.771,0,3.139,1.449,3.139,3.22-.081.886-.403,1.69-.966,2.254h0Z",
        },
      }),
      _c("path", {
        staticStyle: { "stroke-width": "0px" },
        attrs: {
          d: "m42.756,62.467c0-2.656-2.093-4.749-4.749-4.83-2.576,0-4.749,2.093-4.749,4.749,0,1.288.483,2.495,1.368,3.381s2.093,1.449,3.381,1.449,2.415-.483,3.381-1.368c.885-.965,1.368-2.173,1.368-3.38h0Zm-2.576,2.174c-.563.563-1.368.885-2.254.885-.805,0-1.61-.322-2.254-.966s-.885-1.368-.885-2.254c0-1.771,1.449-3.139,3.139-3.139,1.771,0,3.139,1.449,3.139,3.22.081.885-.241,1.69-.885,2.254h0Z",
        },
      }),
      _c("path", {
        staticStyle: { "stroke-width": "0px" },
        attrs: {
          d: "m49.839,67.217c1.288,0,2.495-.483,3.381-1.368s1.449-2.093,1.449-3.381c0-2.656-2.093-4.749-4.749-4.83-2.576,0-4.749,2.093-4.749,4.749,0,1.288.483,2.495,1.368,3.381s2.013,1.368,3.3,1.449h0Zm0-7.969c1.771,0,3.139,1.449,3.139,3.22,0,.805-.322,1.61-.966,2.254-.563.563-1.368.885-2.254.885-.805,0-1.61-.322-2.254-.966-.644-.644-.885-1.368-.885-2.254.081-1.771,1.53-3.139,3.22-3.139h0Z",
        },
      }),
      _c("path", {
        staticStyle: { "stroke-width": "0px" },
        attrs: {
          d: "m61.751,57.638c-2.656,0-4.749,2.093-4.83,4.749,0,1.288.483,2.495,1.368,3.381s2.093,1.449,3.381,1.449,2.415-.483,3.381-1.368c.885-.885,1.449-2.093,1.449-3.381,0-2.656-2.092-4.829-4.749-4.829h0Zm2.174,7.003c-.563.563-1.368.885-2.254.885-.805,0-1.61-.322-2.254-.966s-.885-1.368-.885-2.254c0-1.771,1.449-3.139,3.139-3.139,1.771,0,3.139,1.449,3.139,3.22.08.885-.322,1.69-.885,2.254h0Z",
        },
      }),
      _c("path", {
        staticStyle: { "stroke-width": "0px" },
        attrs: {
          d: "m48.23,73.734c0-1.288-.483-2.495-1.368-3.381s-2.093-1.449-3.381-1.449-2.415.483-3.381,1.368c-.885.885-1.449,2.093-1.449,3.381s.483,2.495,1.368,3.381c.885.885,2.093,1.449,3.381,1.449s2.415-.483,3.381-1.368c.885-.885,1.449-2.092,1.449-3.381Zm-4.83,3.139c-.885,0-1.69-.322-2.254-.966-.563-.644-.885-1.368-.885-2.254,0-.805.322-1.61.966-2.254.563-.563,1.368-.885,2.254-.885,1.771,0,3.139,1.449,3.139,3.139-.081,1.852-1.449,3.22-3.22,3.22h0Z",
        },
      }),
      _c("path", {
        staticStyle: { "stroke-width": "0px" },
        attrs: {
          d: "m56.277,68.986c-1.288,0-2.495.483-3.381,1.368s-1.449,2.093-1.449,3.381.483,2.495,1.368,3.381,2.093,1.449,3.381,1.449,2.415-.483,3.381-1.368c.885-.885,1.449-2.093,1.449-3.381s-.483-2.495-1.368-3.381c-.885-.966-2.093-1.449-3.381-1.449Zm0,7.888c-.885,0-1.69-.322-2.254-.966-.563-.644-.885-1.368-.885-2.254,0-.805.322-1.61.966-2.254.563-.563,1.368-.885,2.254-.885,1.771,0,3.139,1.449,3.139,3.139-.081,1.852-1.529,3.22-3.22,3.22h0Z",
        },
      }),
      _c("path", {
        staticStyle: { "stroke-width": "0px" },
        attrs: {
          d: "m49.839,79.368c-2.656,0-4.749,2.093-4.83,4.749,0,2.656,2.093,4.749,4.749,4.83,1.288,0,2.415-.483,3.381-1.368.885-.885,1.449-2.093,1.449-3.381s-.483-2.495-1.368-3.381c-.885-.966-2.092-1.449-3.38-1.449h0Zm2.254,7.003c-.563.563-1.368.885-2.254.885-1.771,0-3.139-1.449-3.139-3.22s1.449-3.139,3.139-3.139c.805,0,1.61.322,2.254.966.644.644.885,1.368.885,2.254,0,.805-.322,1.61-.885,2.254h0Z",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }